<div class="mt-4 min-h-screen flex">
  <div class="placeholder flex flex-col items-start text-start">
    <span class="text-md text-gray-900 font-semibold">{{
      resolvePlaceholders(fields.displayName)
    }}</span>
    <span class="text-2sm text-gray-500 font-medium w-500px">{{
      resolvePlaceholders(fields.helpText)
    }}</span>
  </div>
  <div class="ms-auto">
    <button
      *ngIf="fields?.properties?.buttonProperty?.text"
      [ngStyle]="fields.properties.buttonProperty.style"
      (click)="handleButtonClick(fields)"
    >
      {{ fields.properties.buttonProperty.text }}
    </button>
  </div>
</div>
